import * as React from 'react'

import { DetailImage } from '~shared/components/Detail/DetailImage'

import { useAddonDetailStateCtx } from '../contexts/AddonDetailStateProvider'

type TProps = NoChildren

/**
 * DetailImage connected to addon detail context data.
 */
export const AddonDetailImage: React.FC<TProps> = () => {
  const { addon, isFetching } = useAddonDetailStateCtx()

  return (
    <DetailImage
      imageUrl={addon.image}
      pictogram={addon.pictogram ?? null}
      showPictogramPlaceholder={isFetching}
    />
  )
}
